const mainMap = {
  namespaced: true,
  state: {
    moveEndViewInfo: { lon: 0, lat: 0, zoom: 1 },
    scaleline: 0,
    errorPopup: { type: null, contents: '' },
    stationPopup: '',
    mapConfig: { station: false, route: false },
		// routeViewerPath: []
  },
  getters: {
  },
  mutations: {
    MUT_MOVEEND_VIEWINFO: (state, payload) => {
      state.moveEndViewInfo = payload;
    },
    MUT_MOVEEND_SCALELINE: (state, payload) => {
      state.scaleline = payload;
    },
    MUT_CLICK_ERROR_POPUP: (state, payload) => {
      state.errorPopup = payload;
    },
    MUT_CLICK_STATION_POPUP: (state, payload) => {
      state.stationPopup = payload;
    },
    MUT_MAP_CONFIG: (state, payload) => {
      state.mapConfig = payload;
    },
    // MUT_ROUTE_VIEWER_PATH: (state, payload) => {
    //   state.routeViewerPath = payload;
    // }
  },
  actions: {
  }
}

export default mainMap